/**
 * @file deviceCheck.js
 * @description Utility function for checking if device is mobile or standalone app.
 */


/**
 * Checks if the application is running in standalone mode (PWA).
 * @returns {boolean} True if the app is in standalone mode, false otherwise.
 */
export const isPWA = () => {
    return window.matchMedia('(display-mode: standalone)').matches;
};

/**
 * Checks if the device is a mobile device.
 * @returns {Promise<boolean>} A promise that resolves to true if the device is mobile, false otherwise.
 */
export const isMobileDevice = () => {
    return new Promise((resolve) => {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;

        // Check for iOS devices
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            resolve(true);
            return;
        }

        // Check for Android devices
        if (/android/i.test(userAgent)) {
            resolve(true);
            return;
        }

        // Check for Windows Phone
        if (/windows phone/i.test(userAgent)) {
            resolve(true);
            return;
        }

        // Check for other mobile devices
        if (/mobile/i.test(userAgent)) {
            resolve(true);
            return;
        }

        // Check for other common mobile user agents
        if (/BlackBerry|BB10|PlayBook|Opera Mini|IEMobile|Mobile|webOS/i.test(userAgent)) {
            resolve(true);
            return;
        }

        resolve(false); // Not a mobile device
    });
};

/**
 * Checks if the device is Android.
 * @returns {boolean} True if the device is Android, false otherwise.
 */
export const isAndroid = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    return /android/i.test(userAgent);
};

/**
 * Checks if the device is iOS.
 * @returns {boolean} True if the device is iOS, false otherwise.
 */
export const isIOS = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    return /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
};